__turbopack_context__.v({
  "drawer": "_6-Xc5W_drawer",
});
